import type { ReactNode } from "react";
import { InfoHint } from "./InfoHint";

interface PageHeadingProps {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  /** Reference copy previously shown as a permanent scope-notice banner. */
  info?: { label: string; children: ReactNode };
  /** Refresh buttons, export actions, or environment pills. */
  actions?: ReactNode;
}

/**
 * Single owner of page header layout. Every page routes through this so the
 * action slot lands at the same vertical position on every view.
 */
export function PageHeading({ eyebrow, title, description, info, actions }: PageHeadingProps) {
  return (
    <header className="page-heading">
      <div className="page-heading-copy">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {description || info ? (
          <p className="page-heading-description">
            {description}
            {info ? <InfoHint label={info.label}>{info.children}</InfoHint> : null}
          </p>
        ) : null}
      </div>
      {actions ? <div className="page-heading-actions">{actions}</div> : null}
    </header>
  );
}
